import { CategoryWizard, ItemActionType } from '@/apps/menu/constants';
import {
  CART_ITEM_UPDATE,
  CART_ITEM_ADD,
} from '@/apps/cart/store/types';
import { NO_BUNDLE_ITEM_ID } from '@/config/constants';
import {
  CONFIGURATOR_PRODUCT,
  CONFIGURATOR_UPDATE_ITEM,
  CONFIGURATOR_ADD_ITEM,
  CONFIGURATOR_REMOVE_ITEM,
  CONFIGURATOR_CHANGED_ITEM,
  CONFIGURATOR_UPDATE_QUANTITY,
  CONFIGURATOR_CLEAR,
  CONFIGURATOR_CLEAR_CHANGED_ITEM,
  SHOW_HELP,
  HIDE_HELP,
  CONFIGURATOR_SET_ORDER_ITEM_UPDATE,
  CONFIGURATOR_CLEAR_BUNDLE,
} from './types';

export default {
  /**
   * Set product for configurator. Creates new if needed
   * @param productKey
   * @param orderItemId
   * @param orderItem
   */
  [CONFIGURATOR_PRODUCT]: async ({ commit, dispatch }, {
    productKey,
    orderItemId = null,
    orderItem = {},
  }) => {
    let orderItemTempId = orderItemId;

    if (!orderItemId)  {
      orderItemTempId = await dispatch(
        CART_ITEM_ADD,
        { productKey, orderItem }
      );
    }

    commit(CONFIGURATOR_PRODUCT, {
      productKey,
      orderItemId: orderItemTempId,
      orderItem,
    });
    commit(CONFIGURATOR_SET_ORDER_ITEM_UPDATE);
  },
  /**
   * Update order item with category item in configurator and cart.
   * @param commit
   * @param dispatch
   * @param getters
   * @param categoryChange
   */
  [CONFIGURATOR_UPDATE_ITEM]: (
    { commit, dispatch, getters },
    categoryChange
  ) => {
    const { orderItem, categoryByKey, itemByKey } = getters;
    const {
      categoryKey, itemKey, quantity, modifier, bundleId = null,
    } = categoryChange;
    const { wizardType } = categoryByKey(categoryKey);
    const { actionType } = itemByKey(itemKey);

    const onlyModifierChanged = !!Object.keys(orderItem).length &&
      Object.keys(orderItem).includes(categoryKey.toString()) &&
      Object.keys(orderItem[categoryKey]).includes(itemKey.toString()) &&
      orderItem[categoryKey][itemKey].quantity === quantity;

    const changedItem = {
      itemKey,
      categoryKey,
      quantity,
      bundleId,
    };

    // Update category for order item if category item was selected.
    if (quantity > 0) {
      if (
        orderItem[categoryKey] &&
        wizardType !== CategoryWizard.RADIO &&
        actionType !== ItemActionType.NO_CHOICE
      ) {
        if (orderItem[categoryKey].radio) {
          commit(CONFIGURATOR_REMOVE_ITEM, {
            object: orderItem[categoryKey],
            key:    orderItem[categoryKey].radio,
          });
          commit(CONFIGURATOR_REMOVE_ITEM, {
            object: orderItem[categoryKey],
            key:    'radio',
          });
        }

        commit(CONFIGURATOR_ADD_ITEM, {
          object: orderItem[categoryKey],
          key:    itemKey,
          value:  { quantity, modifier, bundleId },
        });
      } else {
        commit(CONFIGURATOR_ADD_ITEM, {
          object: orderItem,
          key:    categoryKey,
          value:  { [itemKey]: { quantity, modifier, bundleId } },
        });
        if (actionType === ItemActionType.NO_CHOICE) {
          commit(CONFIGURATOR_ADD_ITEM, {
            object: orderItem[categoryKey],
            key:    'radio',
            value:  itemKey,
          });
        }
      }

      Object.assign(changedItem, {
        toDelete:          false,
        deleteAllItems:    false,
        needClearCategory: actionType === ItemActionType.NO_CHOICE
          || itemKey === NO_BUNDLE_ITEM_ID,
      });
    } else if (orderItem[categoryKey]) {
      // Remove item if deselected and item is in order item
      commit(CONFIGURATOR_REMOVE_ITEM, {
        object: orderItem[categoryKey],
        key:    itemKey,
      });

      Object.assign(changedItem, {
        toDelete:          true,
        deleteAllItems:    true,
        needClearCategory: false,
      });
    }

    if (!onlyModifierChanged) {
      commit(CONFIGURATOR_CHANGED_ITEM, changedItem);
    }

    dispatch(CART_ITEM_UPDATE, {
      orderItemId: getters.orderItemId,
      orderItem:   {
        data:       getters.orderItem,
        productKey: getters.currentProductKey,
        quantity:   getters.configuratorQuantity,
      },
    });
  },
  [CONFIGURATOR_UPDATE_QUANTITY]: ({ commit, getters }, {
    quantity,
    orderItemId,
  }) => {
    if (orderItemId === getters.orderItemId) {
      commit(CONFIGURATOR_UPDATE_QUANTITY, quantity);
    }
  },
  [CONFIGURATOR_CLEAR]: ({ commit }) => {
    commit(CONFIGURATOR_CLEAR);
  },

  /**
   * Clear changed item.
   */
  [CONFIGURATOR_CLEAR_CHANGED_ITEM]: ({ commit }) => {
    commit(CONFIGURATOR_CLEAR_CHANGED_ITEM);
  },

  /**
   * Show help message.
   */
  [SHOW_HELP]: ({ commit }) => {
    commit(SHOW_HELP);
  },

  /**
   * Hide help message.
   */
  [HIDE_HELP]: ({ commit }) => {
    commit(HIDE_HELP);
  },

  /**
   * Clear configurator bundle by bundle id.
   * @param commit
   * @param {number} bundleId
   */
  [CONFIGURATOR_CLEAR_BUNDLE]: ({ commit }, { bundleId }) => {
    commit(CONFIGURATOR_CLEAR_BUNDLE, { bundleId });
  },
};



// WEBPACK FOOTER //
// ./src/apps/configurator/store/actions.js